export default {"src":"/_next/static/media/bn.eaf95870.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};